import baseScmService from 'services/baseScmService';

const libraryService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    attachAcademyTopics: build.mutation({
      query: ({ id, academyTopicIds }) => ({
        url: `/libraries/${id}/library-academy-topics`,
        method: 'POST',
        body: {
          academy_topic_ids: academyTopicIds,
        },
      }),
      invalidatesTags: (result, error, { id }) =>
        error ? [] : [{ type: 'Library', id }],
    }),
    createLibrary: build.mutation({
      query: ({ libraryName }) => ({
        url: '/libraries/',
        method: 'POST',
        body: {
          library: {
            title: libraryName,
          },
        },
      }),
    }),
    getLibrary: build.query({
      query: (libraryId) => ({ url: `libraries/${libraryId}` }),
      providesTags: (result, error, libraryId) => {
        return error ? [] : [{ type: 'Library', id: libraryId }];
      },
    }),
    searchLibrary: build.query({
      query: ({ keyword }) => ({
        method: 'GET',
        url: '/libraries/search/',
        params: { q: keyword },
      }),
    }),
    updateLibrary: build.mutation({
      query: ({ id, ...patch }) => ({
        url: `/libraries/${id}`,
        method: 'PUT',
        body: patch,
      }),
      invalidatesTags: (result, error, { id }) =>
        error ? [] : [{ type: 'Library', id }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAttachAcademyTopicsMutation,
  useCreateLibraryMutation,
  useGetLibraryQuery,
  useLazySearchLibraryQuery,
  useUpdateLibraryMutation,
} = libraryService;

export default libraryService;
